<template>
  <div>
    <v-menu offset-y top left v-model="menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
          {{ $t("ManageListing") }}
          <v-icon class="ml-1" v-if="menu">mdi-menu-down</v-icon>
          <v-icon class="ml-1" v-else>mdi-menu-up</v-icon>
        </v-btn>
      </template>
      <v-list dense color="light-blue darken-4" dark elevation="24">
        <v-list-item
          :to="{
            name: 'EditListingComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-file-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditListing") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditPriceComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditPrice") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditImagesComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-image-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditImages") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditVideoComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-video</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditVideo") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditYoutubeVideoComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-youtube</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("string608") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditMapComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-map-marker-radius</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditMap") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{
            name: 'EditAvailabilityComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-calendar-month</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditAvailability") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="data.contract"
          :to="{
            name: 'PartnerContractComponent',
            params: { id: data.id }
          }"
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-notebook-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("EditContract") }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-else @click="buildContract(data.id)">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-notebook-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("BuildContract") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="
            archiveList({
              property_id: data.id,
              is_archived: !data.is_archived
            })
          "
        >
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-archive</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-if="!data.is_archived">{{
            $t("ArchiveThisListing")
          }}</v-list-item-title>
          <v-list-item-title v-else>{{
            $t("UnArchiveThisListing")
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </div>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import PartnerService from "@/services/PartnerService";
import ListingService from "@/services/ListingService";
import swal from "sweetalert";

export default {
  name: "EditMenuComponent",
  props: ["data"],
  components: { WaitDialogComponent },
  data() {
    return {
      menu: true,
      waitDialog: false
    };
  },
  methods: {
    archiveList(val) {
      let message;
      if (val.is_archived) {
        message = this.$t("string693");
      } else {
        message = this.$t("string694");
      }
      swal({
        text: message,
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.waitDialog = true;
          ListingService.archiveListing(val)
            .then(() => {
              this.waitDialog = false;
              this.$emit("getListing");
            })
            .catch(err => {
              this.error = err.response.data.error;
              this.waitDialog = false;
            });
        }
      });
    },
    buildContract(val) {
      this.waitDialog = true;
      PartnerService.createContract({
        title: "General Lease Agreement",
        description:
          "This Commercial Lease Agreement is made and effective March 01, 2017, by and between Landlord and Tenant.",
        property_id: val
      })
        .then(result => {
          this.waitDialog = false;
          this.$router.push({
            name: "PartnerContractComponent",
            params: { id: result.data.contract.property_id }
          });
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.errors;
        });
    }
  }
};
</script>

<style></style>
